/**
 * Csv Schema of ErroIntegracao
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {ErroIntegracao} from '@/model/resource/ErroIntegracao'

export class CsvErroIntegracaoSchema extends Schema {
  readonly name = 'CsvErroIntegracao'

  readonly fieldSet: FieldSet<ErroIntegracao> = {
    idErroPk: schema => schema.model.idErroPk,
    cnpj: schema => Helper.cnpj(schema.model.responsavel?.cnpj),
    razaoSocial: schema => schema.model.responsavel?.razaoSocial ?? '',
    nf: schema => schema.model.nf,
    danfe: schema => schema.model.danfe,
    response: schema => schema.model.response,
    quant: schema => schema.model.quant,
    data: schema => Helper.datetime(schema.model.data),
  }
}
